import { Box } from '@mui/system'
import React from 'react'
//import image from '../images/logo-m.png'

const LogoMain = () => {
  return (
    <Box width='100%' display='flex' justifyContent='center' alignItems='center'>
      <img src={'./images/logo-m.png'} alt="Worten" height={75} width="auto" style={{ maxWidth: '100%' }} />
    </Box>
  )
}

export default LogoMain